import React, { useRef, useEffect } from 'react';
import PageLayout from "../../../../UiKit/Wizard/Page/PageLayout";
import liveChatStartedImage from '../../../../Images/liveChatStarted.svg';
import './liveChatCard1.css';
import Lottie from "react-lottie";
import welcomLottie from '../welcomeLivechat.json';
import translation from "../translation";
import { useLanguage } from "../../../../UiKit/Wizard/langugeContext";

const LiveChatCard1 = () => {
  
  const containerRef = useRef(null);
  const { currentLanguage } = useLanguage();
  const liveChatTranslations = translation[currentLanguage]["LiveChatCard1"];

  useEffect(() => {
    const bubble = containerRef.current && containerRef.current.closest('.bubble');
    const row = containerRef.current && containerRef.current.closest('.webchat__row');
  
    if (bubble) {
      bubble.style.border = 'none';
      bubble.style.boxShadow = 'none';
    }
  
    if (row && row.style.display === 'none') {
      // console.log('Fixing display none on row');
      row.style.display = 'block';
    }
  
    // console.log("LiveChatCard1 component rendered");
  }, []);
  

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: welcomLottie,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};


  return (
    <div ref={containerRef} className="livechat-card1-wrapper">
      <PageLayout>
        <PageLayout.Content>
          <div className="livechat-container">
            <div className="livechat-header-line">
              <span className="livechat-title">{ liveChatTranslations.livechartStarted
                }</span>
              <div className="livechat-line" />
            </div>

            {/* <img
              src={liveChatStartedImage}
              alt="Live Chat Started"
              className="livechat-image"
            /> */}
            <div style={{ textAlign: "center", marginTop: "43px", marginBottom
            : "20px",
             }}>
                    <Lottie
                        options={defaultOptions}
                        height={83}
                        width={106}
                    />
                </div>

            <div className="livechat-welcome-text">
              { liveChatTranslations.welcomeText }
            </div>
          </div>
        </PageLayout.Content>
      </PageLayout>
    </div>
  );
};

export default LiveChatCard1;
